export default {
  bot: 'Bot',
  name: 'Fila',
  waitingTickets: 'Tickets aguardando',
  openedTickets: 'Tickets em atendimento',
  averageResponseTime: 'Tempo médio de resposta',
  averageAttendanceTime: 'Tempo de atendimento',
};
